import * as React from "react";
import CloTabbedPage from "./CloTabbedPage";
import TransactionsList from "./TransactionsList";
import Reconciliation from "./Reconciliation";
import AccountsList from "./AccountsList";
import InvoicesList from "./InvoicesList";
import PaymentsList from "./PaymentsList";
import Arrears from "./Arrears";
import Reports from "./Reports";
import Wallets from "./Wallets";
import Adjustments from "./Adjustments";
import Breakage from "./Breakage";

export const CloTransactionsDashboard = () => (
  <CloTabbedPage
    title="Transactions"
    tabs={[
      { key: "transactions", label: "Transactions", render: () => <TransactionsList /> },
      { key: "reconciliation", label: "Reconciliation", render: () => <Reconciliation /> },
    ]}
  />
);

export const CloBillingDashboard = () => (
  <CloTabbedPage
    title="Billing & Invoicing"
    tabs={[
      { key: "accounts", label: "Billing accounts", render: () => <AccountsList /> },
      { key: "invoices", label: "Invoices", render: () => <InvoicesList /> },
      { key: "payments", label: "Payments", render: () => <PaymentsList /> },
      { key: "arrears", label: "Arrears", render: () => <Arrears /> },
      { key: "reports", label: "Reports", render: () => <Reports /> },
    ]}
  />
);

export const CloWalletsDashboard = () => (
  <CloTabbedPage
    title="Wallets"
    tabs={[
      { key: "wallets", label: "Wallets", render: () => <Wallets /> },
      { key: "adjustments", label: "Adjustments", render: () => <Adjustments /> },
      { key: "breakage", label: "Breakage", render: () => <Breakage /> },
    ]}
  />
);
